<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      accessToken: '',
      groupId: '',
      confirmationCode: '',
      secretKey: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    accessToken: { required },
    groupId: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) {
        return;
      }

      try {
        const vkChannel = await this.$store.dispatch(
          'inboxes/createChannel',
          {
            name: `VK ${this.groupId}`,
            channel: {
              type: 'vk',
              access_token: this.accessToken,
              group_id: this.groupId,
              confirmation_code: this.confirmationCode,
              secret_key: this.secretKey,
            },
          }
        );

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: vkChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.CREATE_ERROR')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.HEADER_CONTENT')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.accessToken.$error }">
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.ACCESS_TOKEN_LABEL') }}
          <input
            v-model="accessToken"
            type="password"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.ACCESS_TOKEN_PLACEHOLDER')"
            @blur="v$.accessToken.$touch"
          />
          <span class="message" v-if="v$.accessToken.$error">
            {{ $t('INBOX_MGMT.ADD.AUTH.COMMON.REQUIRED_FIELD') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label :class="{ error: v$.groupId.$error }">
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.GROUP_ID_LABEL') }}
          <input
            v-model="groupId"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.GROUP_ID_PLACEHOLDER')"
            @blur="v$.groupId.$touch"
          />
          <span class="message" v-if="v$.groupId.$error">
            {{ $t('INBOX_MGMT.ADD.AUTH.COMMON.REQUIRED_FIELD') }}
          </span>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.CONFIRMATION_CODE_LABEL') }}
          <input
            v-model="confirmationCode"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.CONFIRMATION_CODE_PLACEHOLDER')"
          />
          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.CONFIRMATION_CODE_HELP') }}
          </p>
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0 mt-4">
        <label>
          {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.SECRET_KEY_LABEL') }}
          <input
            v-model="secretKey"
            type="password"
            :placeholder="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.SECRET_KEY_PLACEHOLDER')"
          />
          <p class="help-text">
            {{ $t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.SECRET_KEY_HELP') }}
          </p>
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.AUTH.CHANNEL.VK.FORM.CREATE_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
